import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';
import { MdmPage } from '@/domains/credit';

// El router coacciona `?imei=359123456789012` a número: se acepta y se normaliza a texto.
// `.catch(undefined)` descarta solo el parámetro inválido, nunca los dos.
const deepLinkParam = z
    .union([z.string(), z.number()])
    .transform(String)
    .optional()
    .catch(undefined);

const searchSchema = z.object({
    imei: deepLinkParam,
    credit: deepLinkParam,
});

export type MdmSearch = z.infer<typeof searchSchema>;

/** Deep links: `?imei=` abre ese equipo y `?credit=` acepta `CR-1188` o el id del crédito.
 *  Un parámetro cosmético nunca tumba la ruta: lo que no valida se ignora. */
export function parseMdmSearch(search: Record<string, unknown>): MdmSearch {
    const parsed = searchSchema.safeParse(search);
    return parsed.success ? parsed.data : {};
}

// Ruta estática: gana sobre la dinámica hermana `$section` (que sigue cubriendo el resto).
export const Route = createFileRoute('/_backoffice/credit/mdm')({
    // El IMEI puede llegar como número: así el router no lo serializa entre comillas.
    validateSearch: (search: { imei?: string | number; credit?: string } & SearchSchemaInput) =>
        parseMdmSearch(search),
    component: CreditMdm,
});

function CreditMdm() {
    const { imei, credit } = Route.useSearch();
    return <MdmPage imei={imei} credit={credit} />;
}
